import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "../../../../shared/models";

interface Props {
  data: {
    session: {
      session_id: string;
      session_name: string;
      skill_name: string;
    };
    message: string;
  };
}

export const ActiveSessionWidget: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(`${MainRoutes.Chat}?sessionId=${data.session.session_id}`);
  };

  return (
    <div className="bg-card rounded-xl border-2 border-border/50 p-4 mt-2 shadow-sm">
      <h4 className="font-semibold text-foreground mb-2">{t('widgets.sessionInProgress')}</h4>

      <div className="bg-muted/50 rounded-xl p-3 mb-3 border border-border/30">
        <p className="font-medium text-foreground">{data.session.session_name}</p>
        <p className="text-xs text-muted-foreground">{data.session.skill_name}</p>
      </div>

      <p className="text-sm text-muted-foreground mb-3">{data.message}</p>

      <button
        onClick={handleContinue}
        className="w-full px-4 py-2 bg-primary text-white text-sm rounded-full hover:bg-primary/90 transition-all shadow-sm"
      >
        {t('common.continue')}
      </button>
    </div>
  );
};
